var Module = {
    name: 'floatLabel',
    selectors: {
        form: '.lh-float-label-form',
        label: '.lh-float-label',
        text: '.lh-float-label-text',
    },

    init: function () {
        let form = $(Module.selectors.form);

        if(form.lengh === 0) {
            return;
        }

        $('input,select,textarea,select', form).each(function(e) {
            let input = $(this);
            let labelParent = input.closest(Module.selectors.label);
            if (input.val() !== '' && input.val() !== null) {
                labelParent.addClass('lh-float-label-active');
            } else {
                labelParent.removeClass('lh-float-label-active');
            }
        })

        $(document).on('keyup', Module.selectors.form + ' input,select,textarea', function(e) {
            let input = $(this);
            let labelParent = input.closest(Module.selectors.label);
            if (input.val() !== '' && input.val() !== null) {
                labelParent.addClass('lh-float-label-active');
            } else {
                labelParent.removeClass('lh-float-label-active');
            }
        })

        $(document).on('select2:select', Module.selectors.form + ' select', function(e) {
            let input = $(this);
            let labelParent = input.closest(Module.selectors.label);
            if (input.val() !== '' && input.val() !== null) {
                labelParent.addClass('lh-float-label-active');
            } else {
                labelParent.removeClass('lh-float-label-active');
            }
        })
    }
}

module.exports = Module
